var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"center-message-spinner"},[_c('div',{staticClass:"lds-dual-ring"}),_c('div',[_vm._v(" Wacht voor authenticatie... ")])])])
}]

export { render, staticRenderFns }